const sectionFreestyleHurryBoxCss = `
[data-type='section-freestyle-hurry-box'] [data-attribute='content'] {
  padding-top: var(--padding-top-desktop, 0);
  padding-bottom: var(--padding-bottom-desktop, 0);
}

[data-type='section-freestyle-hurry-box'] [data-attribute='content'] figure {
  overflow-x: auto;
  overflow-y: hidden;
}

@container (max-width: 768px) {
  [data-type='section-freestyle-hurry-box'] [data-attribute='content'] {
    padding-top: var(--padding-top-mobile, 0);
    padding-bottom: var(--padding-bottom-mobile, 0);
  }

  [data-type='section-freestyle-hurry-box'] [data-attribute='content'] figure {
    width: 98% !important;
  }
}
`;
export default sectionFreestyleHurryBoxCss;
